import request from './request';

/**
 * 关联知识到 Worker
 */
export function associateKnowledges(workerId, knowledgeAssociations) {
  return request({
    url: `/worker/${workerId}/associate-knowledges`,
    method: 'post',
    data: {
      knowledge_associations: knowledgeAssociations
    }
  });
}

/**
 * 设置提示词结构
 */
export function setPromptTemplate(workerId, knowledgeId) {
  return request({
    url: `/worker/${workerId}/set-prompt-template`,
    method: 'post',
    data: {
      knowledge_id: knowledgeId
    }
  });
}

/**
 * 获取 Worker 关联的知识列表
 */
export function getAssociatedKnowledges(workerId) {
  return request({
    url: `/worker/${workerId}/associated-knowledges`,
    method: 'get'
  });
}

/**
 * 预览提示词结构
 */
export function previewPromptTemplate(workerId) {
  return request({
    url: `/worker/${workerId}/preview-prompt-template`,
    method: 'get'
  });
}

/**
 * 移除单个知识关联
 */
export function removeKnowledge(workerId, knowledgeId) {
  return request({
    url: `/worker/${workerId}/knowledge/${knowledgeId}`,
    method: 'delete'
  });
}

